/* eslint-disable camelcase */
import React, { useEffect, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useHistory, useLocation } from 'react-router-dom';
import KeepAlive, { useActivate, useUnactivate } from 'react-activation';

import { logging, logPostInfo } from '../../../actions/log';
import styles from './ForumDetail.module.less';
// import { CONTEXT } from '../../../config';
import Loading from '../../../components/Loading/Loading';
import ForumBar from '../ForumBar/ForumBar';
import ForumDetailInfo from './ForumDetailInfo';
import ForumComment from './ForumComment';
import ForumCommentList from './ForumCommentList';
import ForumReview from '../ForumReview/ForumReview';

import ForumDefault from '../ForumDefault/ForumDefault';
import { getForumDetail, getForumDetailMore } from '../../../actions/forum';
import { getQueryString } from '../../../utils/utils';
import ForumOverview from './ForumOverview';
import Login from '../../../components/Forum/Login/Login';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);

const selectForumDetail = createSelector(
  state => state.forum,
  forum => forum.forumDetail,
);
const selectForumDetailMore = createSelector(
  state => state.forum,
  forum => forum.forumDetailMore,
);

function ForumDetail() {
  const dispatch = useDispatch();
  // const userInfo = useSelector(selectUserInfo);
  const logInfoData = useSelector(selectLogInfo);
  const forumDetail = useSelector(selectForumDetail);
  const forumDetailMore = useSelector(selectForumDetailMore);

  const [loginPanel, setLoginPanel] = useState(false);
  const userId = window.CallNativeMethod && window.CallNativeMethod('get_user_id');
  const loginST = window.CallNativeMethod && window.CallNativeMethod('get_st');
  const [loginStatus, setLoginStatus] = useState(!!(loginST !== '' && userId));

  // const isDownload = getQueryString('isDownload');
  const id = getQueryString('id');
  const [commentNode, setCommentNode] = useState(null);

  const [initTime, setInitTime] = useState(+new Date());

  // 浏览时长打桩
  const leaveTimeLog = useCallback(() => {
    const leaveTime = +new Date();
    dispatch(
      logging({
        category: 'I',
        action: 'View_Time',
        label: '',
        param2: {
          source: `Forum_Detail`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          initTime,
          leaveTime,
          time: leaveTime - initTime,
        },
      }),
    );
  }, [initTime]);

  const pagePvLog = useCallback(() => {
    dispatch(
      logging({
        category: 'P',
        action: 'Forum_Detail',
        label: '',
        param2: {
          source: 'Forum_Detail',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          id,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: 'Forum_Detail',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  });

  useActivate(() => {
    setInitTime(+new Date());
  });
  useUnactivate(() => {
    leaveTimeLog();
  });

  useEffect(() => {
    pagePvLog();
  }, []);
  useActivate(() => {
    pagePvLog();
  });

  useEffect(() => {
    if (id) {
      dispatch(getForumDetail({ id }));
      dispatch(getForumDetailMore({ id }));
    }
  }, [loginStatus]);

  useActivate(() => {
    if (forumDetailMore.id !== id) {
      dispatch(getForumDetail({ id }));
      dispatch(getForumDetailMore({ id }));
    }
  });

  if (
    !forumDetail ||
    !forumDetail.id ||
    !forumDetailMore ||
    !forumDetailMore.id ||
    forumDetailMore.id !== id
  ) {
    return (
      <div className={styles.loading}>
        <ForumBar />
        <Loading />
      </div>
    );
  }
  if (
    !forumDetail ||
    !forumDetail.id ||
    !forumDetailMore ||
    !forumDetailMore.id ||
    forumDetailMore.status === -2
  ) {
    return (
      <div className={styles.loading}>
        <ForumBar />
        <ForumDefault />
      </div>
    );
  }

  return (
    <div className={styles.forum} id="forum_detail">
      <div className={styles.forum_cont}>
        <ForumBar />

        <div className={styles.forum_detail}>
          {forumDetailMore && forumDetailMore.title && forumDetail && forumDetail.id && (
            <ForumDetailInfo forumDetailMore={forumDetailMore} forumDetail={forumDetail} />
          )}
          <div
            className={styles.forum_detail_content}
            dangerouslySetInnerHTML={{
              __html: forumDetailMore.text,
            }}
          />
          <div ref={r => setCommentNode(r)}>
            <ForumComment forumDetailMore={forumDetailMore} forumDetail={forumDetail} />
          </div>
          <ForumCommentList data={forumDetailMore} />
          <ForumReview />
          <ForumOverview forumDetail={forumDetail} commentNode={commentNode} />
          <Login
            getLoginStatus={state => setLoginStatus(state)}
            callLoginPanel={loginPanel}
            resetLoginPanel={() => {
              setLoginPanel(false);
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default () => {
  const id = getQueryString('id');
  return (
    <KeepAlive name="forumdetail" id={id}>
      <ForumDetail />
    </KeepAlive>
  );
};
